import styles from "./EditMapMenu.module.css";
import EditMapPlacements from "./EditMapPlacements";
import EditMapTitle from "./EditMapTitle";
import EditMapTheme from "./EditMapTheme";
import ClearMapButton from "../top-ui/ClearMapButton";
import EditMapSize from "./EditMapSize";
import SaveJsonButton from "./SaveJsonButton";

export default function EditMapMenu({ level }) {
  if (!level.isEditMode) {
    return null;
  }
  return (
    <div className={styles.editMapMenu}>
      <EditMapTitle level={level} />
      <EditMapPlacements />
      <div className={styles.buttonContainer}>
        <EditMapTheme level={level} />
      </div>
      <div className={styles.buttonContainer}>
        <ClearMapButton level={level} />
      </div>
      <div className={styles.buttonContainer}>
        <EditMapSize level={level} />
      </div>
      <div className={styles.buttonContainer}>
        <SaveJsonButton level={level} />
      </div>
    </div>
  );
}
